import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { AppAlertJSON } from '../../../components/AppAlerts/AppAlerts'

interface AlertsState {
  alerts: (AppAlertJSON)[]
}

const initialState: AlertsState = {
  alerts: []
}

const alertsSlice = createSlice({
  name: 'alerts',
  initialState,
  reducers: {
    addAlert(state, payload: PayloadAction<AppAlertJSON>) {
      state.alerts.push(payload.payload)
    },
    removeAlert(state, payload: PayloadAction<number>) {
      state.alerts = state.alerts.filter(x => x.id !== payload.payload)
    }
  }
})

export const { addAlert, removeAlert } = alertsSlice.actions
export default alertsSlice.reducer